import React from 'react';
import { SectionHeading } from './SectionHeading';
import { paths } from '../data/content';
export function Paths() {
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-141" data-mp="wiy6nq1b30av">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-142" data-mp="rqoj2gnnycbr">
        <SectionHeading eyebrow="Cómo se usa" title={<>
              Un sistema. Dos etapas.{' '}
              <span className="italic text-gold-700" data-id="element-144" data-mp="iqrnrw6rqf7q">Diferentes formas de acompañar.</span>
            </>} data-id="element-143" data-mp="rottgp1g5w1c" />

        <ul className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-145" data-mp="dq41toxecokd">
          {paths.map(path => <li key={path.title} className="flex h-full flex-col overflow-hidden rounded-xl bg-white shadow-card" data-id="element-146" data-mp="8t3s941c93oi">
              <h3 className="bg-plum-300 px-6 py-5 text-center font-display text-lg font-bold leading-snug text-white" data-id="element-147" data-mp="2363dbcohmq36">
                {path.title}
              </h3>

              <div className="flex flex-1 flex-col px-6 py-8" data-id="element-148" data-mp="1z59pejb1pbaa">
                <ol data-id="element-149" data-mp="16ds4uouegby3">
                  {path.steps.map((step, index) => <li key={step} data-id="element-150" data-mp="1bcv2vpbyphwk" data-mpi={index}>
                      {index > 0 && <div className="mx-auto flex h-8 items-center justify-center font-display text-xl font-bold text-teal-500" aria-hidden="true" data-id="element-151" data-mp="1bas1ya99u4d2">
                          {path.connector}
                        </div>}
                      <p className="rounded-lg bg-cream px-4 py-3 text-center font-semibold text-ink ring-1 ring-plum-100" data-id="element-152" data-mp="1u3cqxglunpbl">
                        {step}
                      </p>
                    </li>)}
                </ol>

                <p className="mt-auto pt-7 text-center leading-relaxed text-muted" data-id="element-153" data-mp="1kc9s6lge7mfh">
                  {path.description}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-xl font-bold italic leading-snug text-plum-700 md:text-2xl" data-id="element-154" data-mp="2cvoqjvl4cci1">
          Elegís la herramienta según la edad, el momento y la necesidad.
        </p>
      </div>
    </section>;
}